import React, { useContext } from 'react';
import { useChatLink } from '../../hooks';
import * as S from './styled';
import { AppContext } from '../../context';

const Chat = () => {
  const { chatURL } = useChatLink();
  const { setContext, showEmbeddedChat, minimized } = useContext(AppContext);

  const handleChat = () => {
    if (!showEmbeddedChat) {
      setContext({
        urlChat: chatURL(),
        showEmbeddedChat: true,
        minimized: false,
      });
    } else {
      setContext({
        minimized: false,
      });
    }
  };

  return (
    <>
      {(minimized || !showEmbeddedChat) && (
        <S.Chat
          onClick={() => {
            handleChat();
          }}
        >
          Chat <span className="dots">---</span>
        </S.Chat>
      )}
    </>
  );
};

export default Chat;
